module.exports = __webpack_public_path__ + "img/avatar3.f2b37ebd.png";